import React from "react";
import { NakiNigunImportBatchPreviewTemplate } from "themes/administration/naki-nigun-import/pages";
import { NakiNigunImportBatchPreviewViewStore } from "administration/naki-nigun-import/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiNigunImportBatchPreviewViewStore(rootStore, componentProps),
    "nakiNigunImportBatchPreviewViewStore"
)
class NakiNigunImportBatchPreview extends React.Component {
    render() {
        return <NakiNigunImportBatchPreviewTemplate {...this.props} />;
    }
}

export default NakiNigunImportBatchPreview;
